import React, { Component } from 'react'
import { Form, Input, Button, Icon, Alert } from 'antd'
import { sendNotification } from '../../utils/index'
import { connect } from 'react-redux'
import { injectIntl, FormattedMessage } from 'react-intl'
import folderIco from '../../assets/images/folder.png'
import { signin, logout, recoveryPassword, restartRecovery } from '../../actions/AuthAction'
import { VERSION } from '../../utils'
import { withRouter } from 'react-router'
import './login.css'
import ReCAPTCHA from "react-google-recaptcha";

export class Login extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: '',
      password: '',
      formLoginRecovery: false,
      btnRecovery: false
    }
  }

  componentDidMount() {
    this.props.logout()
    localStorage.clear()
  }

  componentDidUpdate(prevProps) {
    const { user, passRecovered, error, intl } = this.props
    const { formLoginRecovery } = this.state

    if (user && user.role) {
      if (user.role === 'cmo') {
        this.props.history.push(`/manager/cms`)
      } else {
        this.props.history.push(`/client-selector`)
      }
    }

    if (passRecovered && formLoginRecovery) {
      sendNotification('success', intl, intl.formatMessage({ id: 'mail_new_password' }))
      this.handleSwitchForm()
      this.props.restartRecovery()
    }

    if ((prevProps.error !== error) && formLoginRecovery && !passRecovered && error) {
      sendNotification('error', intl, intl.formatMessage({ id: 'not_recover_password' }))
      this.handleSwitchForm()
      this.props.restartRecovery()
    }
  }

  handleOnInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSwitchForm = () => {
    const { formLoginRecovery } = this.state
    this.setState({
      formLoginRecovery: !formLoginRecovery,
      password: '',
      btnRecovery: false
    })
  }

  handleSubmit = (e) => {
    const { email, password, formLoginRecovery } = this.state
    const { intl } = this.props
    e.preventDefault()
    if (!formLoginRecovery) {
      this.props.signin({ email, password })
    }
    else {
      if (email !== '')
        this.props.recoveryPassword(intl, email)
      else
        sendNotification('warning', intl, intl.formatMessage({ id: 'empty_email_input' }))
    }
  }

  render() {
    const { email, password, formLoginRecovery, btnRecovery } = this.state
    const { intl, error, isFetching } = this.props
    const hash = '#'

    return (
      <Form onSubmit={this.handleSubmit} className="login-form">
        {!formLoginRecovery &&
          <React.Fragment>
            <Form.Item>
              <Input
                name="email"
                type="email"
                value={email}
                prefix={<Icon
                  type="user"
                  style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="Email"
                onChange={this.handleOnInputChange} />
            </Form.Item>
            <Form.Item>
              <Input
                name="password"
                value={password}
                prefix={<Icon
                  type="lock"
                  style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                placeholder={intl.formatMessage({ id: "login_password" })}
                onChange={this.handleOnInputChange} />
            </Form.Item>
            <Form.Item>
              <a href={hash} className="login-form-forgot" onClick={this.handleSwitchForm}>
                <FormattedMessage id="login_forgotPassword" />
              </a>
              <Button loading={isFetching} type="primary" htmlType="submit" disabled={(email === '' && password === '')} className="login-form-button">
                <FormattedMessage id="login" />
              </Button>
              {error && error.status && <Alert
                message={intl.formatMessage({ id: "login_not_valid" })}
                type="error"
              />}
            </Form.Item>
            <img src={folderIco} alt="folder" style={{ width: 250 }} />
          </React.Fragment>
        }
        {formLoginRecovery &&
          <React.Fragment>
            <Form.Item>
              <Input
                name="email"
                type="email"
                value={email}
                prefix={<Icon
                  type="user"
                  style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="Email"
                onChange={this.handleOnInputChange} />
            </Form.Item>
            <Form.Item>
              <ReCAPTCHA
                sitekey="6LdsuqcUAAAAAJQXHt9tSCVdyPpTqFKczH3q3bMM"
                onChange={() => {
                  this.setState({
                    btnRecovery: true
                  })
                }}
              />
            </Form.Item>
            <Form.Item>
              <a href={hash} className="login-form-forgot" onClick={this.handleSwitchForm}>
                <FormattedMessage id="login_back" />
              </a>
              <Button disabled={!btnRecovery} loading={isFetching} type="primary" htmlType="submit" className="login-form-button">
                <FormattedMessage id="login_recoveryPassword" />
              </Button>
            </Form.Item>
          </React.Fragment>
        }
        <div style={{
          position: 'absolute',
          bottom: 10,
          color: '#ccc',
          right: 20
        }}>v{VERSION}</div>
      </Form>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.authUser.user,
    error: state.authUser.error,
    isFetching: state.authUser.isFetching,
    passRecovered: state.authUser.passRecovered
  }
}

const mapDispatchToProps = {
  signin,
  logout,
  recoveryPassword,
  restartRecovery
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Login)))